import React, { createRef } from "react";
import { cl, getRandomString } from "../../components/utils/utils";
import history from "../../history"
import Gauge2 from '../../visualization/components/Gauge01'
import {getEquipmentStatus} from './C18EquipmentStatus00'
import { getParamId } from "../utils/utils";
import { dbVals } from "../../components/utils/http";
import { getChannelType } from "./C18utils";

class C18PhysicalView extends React.Component {

  constructor(props) {
      super(props)
      this.colorArr=[
        "#009fb9", 
        "#df568b", "#9b8610", "#348bed", "#dc5e59", "#679525", 
        "#00a086", 
        "#9478e0", 
          "#c3732e", "#009d52", "#0098df", "#c862bc"
      ]
      this.state = {
        drawing: false,
        startX: 0,
        startY: 0,
        currGrouping: null,
        currPoint: null,
        currReading: null,
        offsetX: 0,
        offsetY: 0,
      }
      this.canvasWidth = 1920
      this.canvasHeight = 1080
      this.containerRef = createRef();
  }

  handleMouseDown = (e) => {
    cl("div mouse down")
    // always adding a group if clicking on div
    if (!this.props.parms.editing || this.currGrouping || this.currPoint) return;
    const rect = this.containerRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    this.setState({
      drawing: true,
      startX: x,
      startY: y,
    });
  };

  handleMouseMove = (e, element) => {
    const { currGrouping, currPoint, currReading, offsetX, offsetY } = this.state;
    if (!this.props.parms.editing || (element.id !== currGrouping?.id && element.id !== currPoint?.id && element.id !== currReading?.id)) return;
    
    const containerRect = this.containerRef.current.getBoundingClientRect();
    const mouseX = e.clientX - containerRect.left;
    const mouseY = e.clientY - containerRect.top;
    
    const newX = mouseX - offsetX;
    const newY = mouseY - offsetY;
    if (element.id === currGrouping?.id) {
      this.props.parms.onChange({cmd: "moveGrouping", vals: {currGrouping: currGrouping, newX: newX, newY: newY}});
    } else if (element.id === currPoint?.id) {
      this.props.parms.onChange({cmd: "movePoint", vals: {currPoint: currPoint, newX: newX, newY: newY}});
    } else if (element.id === currReading?.id) {
      this.props.parms.onChange({cmd: "moveReading", vals: {currReading: currReading, newX: newX, newY: newY}});
    }
  }

   handleMouseUp = (e) => {
    cl("div mouse up")
    const { startX, startY, drawing, currGrouping, currPoint, currReading } = this.state;
    if (!drawing || !this.props.parms.editing) return;
    if (currGrouping || currPoint || currReading) {
      this.setState({currGrouping: null, currPoint: null, currReading: null})
      return
    }

    const rect = this.containerRef.current.getBoundingClientRect();
    const endX = e.clientX - rect.left;
    const endY = e.clientY - rect.top;
    // cl([startX, endX, startY, endY, startX - endX, startY - endY])
    cl(this.props.parms.groupings)
    const newGrouping = {
      x: Math.min(startX, endX),
      y: Math.min(startY, endY),
      width: Math.abs(endX - startX),
      height: Math.abs(endY - startY),
      rotation: 0,
      name: getRandomString(16),
      id: getRandomString(16),
      color: this.colorArr[Object.keys(this.props.parms.groupings).length], // give color of latest entry in color arr
      points: {},
    };
    cl(newGrouping)
    // check if there's any overlaps with any of the other groupings
    let valid = this.checkValidGrouping(newGrouping)
    // save to groupings in parent component
    if (valid) {
      this.props.parms.onChange({cmd: "createGrouping", val: newGrouping})
      this.setState({
        drawing: false,
      })
    } else {
      // show error msg
      cl("did not create grouping")
    }
  };

  handleGroupingMouseDown = (e, grouping) => {
    cl("grouping mouse down")
    e.stopPropagation()
    const rect = this.containerRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    // how to know which group I'm selecting, need to pass it to parent as well
    // find grouping by id
    this.props.parms.onChange({cmd: "selectGrouping", val: grouping})
    this.setState({
      currGrouping: grouping,
      offsetX: x - grouping.x,
      offsetY: y - grouping.y,
    });
  };

   handleGroupingMouseUp = (e, grouping) => {
    cl("grouping mouse up")
    if (!this.props.parms.editing) return;
    this.setState({currGrouping: null})
  };

  handlePointMouseDown = (e, point) => {
    cl("point mouse down")
    e.stopPropagation()
    const rect = this.containerRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    this.props.parms.onChange({cmd: "selectPoint", val: point})
    this.setState({
      currPoint: point,
      offsetX: x - point.x,
      offsetY: y - point.y,
    });
  };

   handlePointMouseUp = (e, point) => {
    cl("point mouse up")
    if (this.props.parms.editing) {
      this.setState({currPoint: null})
    } else {
      // show more detail (link to sensor/eq page, ?)
    }
  };

  handleReadingMouseDown = (e, reading) => {
    cl("reading mouse down")
    e.stopPropagation()
    const rect = this.containerRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    this.props.parms.onChange({cmd: "selectReading", val: reading})
    this.setState({
      currReading: reading,
      offsetX: x - (reading?.x||0),
      offsetY: y - (reading?.y||0),
    });
  };

   handleReadingMouseUp = (e, reading) => {
    cl("reading mouse up")
    if (this.props.parms.editing) {
      this.setState({currReading: null})
    } else {
      // show more detail (link to sensor/eq page, ?)
    }
  };

  // TODO MAKE INTO UTILS FUNCTION
  isChan=(sensorId)=>{
    let sensor2 = ""
    if(["e0","e1","e2","e3","ca"].includes(sensorId.substring(0,2))){
      sensor2=sensorId.substring(2)
    }
      return ((sensor2[0]==="c")&&(!isNaN(sensor2.substring(1,3))))
  }
  channelNum=(sensorId)=>{
    let sensor2 = ""
    if(["e0","e1","e2","e3","ca"].includes(sensorId.substring(0,2))){
      sensor2=sensorId.substring(2)
      return sensor2.substring(1,3)
    }
  }


  // check new grouping against bounds and return true or false
  checkValidGrouping = (newGrouping) => {
    // validate new grouping

    // should be over a certain size, otherwise that's a point
    if (newGrouping.width < 20 || newGrouping.height < 20) {
      cl("too small")
      return false
    }
    // shouldn't be intersecting with other groupings if of valid size
    // need to check for angle, width, height - TODO later
    // for (let g in this.props.parms.groupings) {
    //   if ((newGrouping.x + newGrouping.width < g.x // to left of g
    //     || (newGrouping.y > g.y && newGrouping.y < (g.y + g.height))) // 
    //     || ((((newGrouping.x + newGrouping.width) > (g.x)) && (newGrouping.x < (g.x + g.width))) // ending inside other rectangle
    //     && ((newGrouping.y + newGrouping.height) < (g.y)) && (newGrouping.y < (g.y + g.height)))) {
    //       cl("intersecting with another rectangle")
    //       return false
    //     }
    // }
    return true
  }

  showGroupings = () => {
    return (
      Object.values(this.props.parms.groupings).map((grouping, i) => {
        let selected = (this.state.currGrouping != null && this.state.currGrouping.id === grouping.id)
        return (
          <div
            key={i}
            onMouseDown={(e) => this.handleGroupingMouseDown(e, grouping)}
            onMouseUp={(e) => this.handleGroupingMouseUp(e, grouping)}
            onMouseMove={(e) => this.handleMouseMove(e, grouping)}
            style={{
              position: "absolute",
              left: grouping.x,
              top: grouping.y,
              rotate: `${grouping.rotation}deg`, // in degrees
              width: grouping.width,
              height: grouping.height,
              border: `${selected ? "2px solidrgb(255, 0, 0)" : "2px solid #FFFFFF"}`,
              backgroundColor: `${grouping.color}75`,
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              textAlign: "center"
            }}>
            <div
                style={{
                  fontFamily: 'Roboto',
                  fontWeight: `${selected ? "bold" : ""}`,
                  fontSize: `16px`,
                  userSelect: "none",
                  overflow: "hidden",
                  cursor: 'pointer',
                  color: 'white',
                  backgroundColor: 'transparent',
                }}>
                {grouping.name}
            </div>
        </div>
        ) 
      })
      )
  }

  test_sensors = [
    {
      "id": "",
      "zoneId": "bap9aJlM5ZTkNkP6",
      "name": "DO",
      "name2": "Dissolved Oxygen",
      "type": "ga",
      "vals": [
          0,
          10,
          100,
          100
      ],
      "cVal": "11.2",
      "cUn": "mg/L",
      "val": "11.2",
      "foot": "Normal",
      "site": "rtaJGu71v8E*LI0k",
      "zone": 4,
      "al": ""
    },
    {
      "id": "",
      "zoneId": "bap9aJlM5ZTkNkP6",
      "name": "Vol",
      "name2": "Level",
      "type": "ga",
      "vals": [
          0,
          10,
          100,
          100
      ],
      "cVal": "412",
      "cUn": "Gal",
      "val": "412",
      "foot": "Normal",
      "site": "rtaJGu71v8E*LI0k",
      "zone": 4,
      "al": ""
    },
    {
      "id": "",
      "zoneId": "bap9aJlM5ZTkNkP6",
      "name": "T",
      "name2": "Tank Temperature",
      "type": "ga",
      "vals": [
          0,
          10,
          100,
          100
      ],
      "cVal": "74",
      "cUn": "°F",
      "val": "74",
      "foot": "Normal",
      "site": "rtaJGu71v8E*LI0k",
      "zone": 4,
      "al": ""
    },
    {
      "id": "",
      "zoneId": "bap9aJlM5ZTkNkP6",
      "name": "Flow",
      "name2": "Flow",
      "type": "ga",
      "vals": [
          0,
          10,
          100,
          100
      ],
      "cVal": "256",
      "cUn": "GPM",
      "val": "256",
      "foot": "Normal",
      "site": "rtaJGu71v8E*LI0k",
      "zone": 4,
      "al": ""
    },
  ]

  // g0 yellow
  // g1 blue
  // g2 green
  // g3 purple
  get_test_sensor = (groupIdx, pointIdx) => {
    let do_vals = [11.2, 4.5, 11.9, 12.1]
    let vol_vals = [412, 472, 125, 477]
    let t_vals = [74, 76, 78, 75]
    let flow_vals = [256, 312, 58, 298]
    let all_vals = [do_vals, vol_vals, t_vals, flow_vals]
    let curr_test_sensor = this.test_sensors[pointIdx%4]
    curr_test_sensor.cVal= all_vals[pointIdx%4][groupIdx%4]
    curr_test_sensor.alarm= (pointIdx === 0 && groupIdx === 1) || (pointIdx === 1 && groupIdx === 2) || (pointIdx === 3 && groupIdx === 2)
    return curr_test_sensor
  }

  makeZuciUrl = (s) => {
    let chTypeId=getParamId("configuration_channels","channelType")    
    let zone = this.props.parms.getZone(s.zoneId)
    let zInd = zone.siteZoneIndex
    let ch = +this.channelNum(s.id)
    let chType=getChannelType(zone.gatewayType, zInd,0)
    // let ch = channelId 
    // cl(zInd, ch, chTypeId, chType)
    let eqType = dbVals.z[zInd][+ch][chTypeId]
    let fuiURL = `/usa/c18/fui/${chType}/${zInd}-${eqType}-${ch}-0`
    return fuiURL
  }

  

  getRandomFloatOneDecimal = (min, max) => {
    // Generate a random number within the desired range
    const randomNumber = Math.random() * (max - min) + min;

    // Convert the number to a string with one decimal place
    const fixedString = randomNumber.toFixed(1);

    // Convert the string back to a float
    return parseFloat(fixedString);
  }

  showPoints = () => {
    // get all groupings
    // get all points from groupings
    return (
      Object.values(this.props.parms.groupings).map((grouping, i) => {
        // check if group is selected
        let selectedGroup = (this.state.currGrouping != null && this.state.currGrouping.id === grouping.id)
        // if in edit mode, view mode partial and selected group, or view mode and view all
        if (
          this.props.parms.editing || 
          (!this.props.parms.editing && (
            (this.props.parms.visibility === 1 && selectedGroup) ||
            (this.props.parms.visibility === 2))
          )
        ) {
          return Object.values(grouping.points).map((point, j) => {
            let selected = (this.state.currPoint != null && this.state.currPoint.id === point.id)
            // highlight if selected
            let sensors = point.sensors
            // if testing, assign test sensors instead
            // if (this.props.parms.testing) {
            //   sensors = []
            //   sensors.push(this.get_test_sensor(i, j))
            // }
            // link point to sensor page if it exists
            return (
              <div
              key={i * 100 + j}
              onMouseDown={(e) => this.handlePointMouseDown(e, point)}
              onMouseUp={(e) => this.handlePointMouseUp(e, point)}
              onMouseMove={(e) => this.handleMouseMove(e, point)}
              style={{
                position: "absolute",
                left: point.x,
                top: point.y,
                width: 15,
                height: 15,
                borderRadius: "50%",
                border: `${selected ? "2px solidrgb(255, 0, 0)" : "2px solid #FFFFFF"}`,
                backgroundColor: `${grouping.color}50`,
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                textAlign: "center"
              }}>
              {
                sensors.map(s => {
                  // generate url for each sensor/eq page
                  // TODO make url work for eq
                  // cl(s)
                  s = Object.assign({groupingId: point.groupingId, pointId: point.id}, s)
                  // cl("s-----", s)
                  let fuiURL = ""
                  if(this.isChan(s.id)) { fuiURL = this.makeZuciUrl(s) }
                  
                  let e = {}

                  let associatedUrl = (this.isChan(s.id)) ? fuiURL : `/usa/c18/sites/${s.site}/zones/${s.zoneId}/sensor/${s.id}`
                  return (
                      <div
                          onMouseDown={(e) => this.handleReadingMouseDown(e, s)}
                          onMouseUp={(e) => this.handleReadingMouseUp(e, s)}
                          onMouseMove={(e) => this.handleMouseMove(e, s)}
                          style={{
                            position: "absolute",
                            left: (s.x !== null) ? s.x : point.x,
                            top: (s.y !== null) ? s.y : point.y,
                            backgroundColor: s.alarm ? '#ff3131' : '#d9d9d9',
                            borderRadius: '8px',
                            padding: '6px'
                          }}
                      >
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', textAlign: "center" }}>
                          <div
                            onClick={()=>{if (!this.props.parms.editing) history.push(associatedUrl)}} 
                            style={{
                              fontFamily: 'Roboto',
                              fontSize: `16px`,
                              textDecoration: (!this.props.parms.editing) ? 'underline' : 'none',
                              cursor: (!this.props.parms.editing) ? 'pointer' : 'default',
                              userSelect: "none",
                              color: (s.alarm) ? 'white' : 'black',
                            }}>
                              {`${s.name}`}
                          </div>
                          <div
                            style={{
                              fontFamily: 'Roboto',
                              fontSize: `16px`,
                              userSelect: "none",
                              color: (s.alarm) ? 'white' : 'black',
                            }}>
                              =
                          </div>
                          <div 
                            style={{
                              fontFamily: 'Roboto',
                              fontSize: `16px`,
                              userSelect: "none",
                              color: (s.alarm) ? 'white' : 'black',
                            }}>
                              {s.cVal}{s.cUn}
                          </div>
                        </div>
                      </div>
                  )
                })
              }
              </div>
            )
          })
        }
      })
    )
  }

  render = () =>  {
    cl(this.props.parms)
    return (
      <div
        ref={this.containerRef}
        onMouseDown={this.handleMouseDown}
        onMouseUp={this.handleMouseUp}
        style={{
          position: "relative",
          display: "block",
          border: "1px solid #ccc",
          marginTop: 20,
          userSelect: "none",
          overflow: "hidden",
        }}
      >
        <img
          src={this.props.parms.bgImgSrc}
          alt="Canvas"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            userSelect: "none",
            pointerEvents: "none",
            WebKitUserDrag: "none" 
          }}
        />
        {(this.props.parms.editing || this.props.parms.visibility > 0) && this.showGroupings()}
        {(this.props.parms.editing || this.props.parms.visibility > 0) && this.showPoints()}
      </div>
    );
  }

}

export default C18PhysicalView;
